import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Container,
  Paper,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import {
  CheckCircle as CheckCircleIcon,
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Navbar";
import { useEffect, useState } from "react";
import { useToast } from "../../../Hooks/UseToast";
import moment from "moment";
import { UrlApi } from "../../../services/apirest";

const OrderConfirmationScreen = () => {
  const [nombreCompleto, setNombreCompleto] = useState("");
  const { Toast, showToast } = useToast();
  const usuario = localStorage.getItem("user");
  const obtenerNombreDeUsuarioCompelto = async (username) => {
    const result = await fetch(`${UrlApi}/viandas/menu/usuarios/${username}`);
    if (!result.ok) {
      showToast(
        "No pudimos obtener tu nombre completo. Lo reemplazaremos por tu nombre de usuario",
        "warning"
      );
      setNombreCompleto(username);
      return;
    }
    const data = await result.json();
    //console.log(data);
    setNombreCompleto(data[0].nombrepila);
    return;
  };

  useEffect(() => {
    obtenerNombreDeUsuarioCompelto(usuario);
    showToast("El pedido se guardo con exito!", "success");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const navigate = useNavigate();

  const handleBackToHome = () => navigate("/navbar");

  const handleBackToSelection = () => {
    navigate("/viandas/selecionarmenu");
    window.location.reload();
  };

  const location = useLocation();
  const { username, pedidos, menus } = location.state || {};

  const changeIdForNameMenu = (idMenu) => {
    return menus.find((m) => m.id_menu === idMenu)?.menu ?? null;
  };

  let pedidosOrdenado = Object.fromEntries(
    Object.entries(pedidos || {}).sort(
      ([fechaA], [fechaB]) =>
        moment(fechaA, "YYYY-MM-DD").toDate() -
        moment(fechaB, "YYYY-MM-DD").toDate()
    )
  );

  pedidosOrdenado = Object.fromEntries(
    Object.entries(pedidosOrdenado).filter(([_, value]) => value?.id_menu !== 0)
  );

  return (
    <>
      {Toast}
      <Navbar />
      <Container
        maxWidth={false}
        sx={{
          backgroundColor: "#f8f9fa",
          p: { xs: 2, sm: 3, md: 5 },
          minHeight: "95vh",
          width: "100%",
          mx: "auto",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            backgroundColor: "#f8f9fa",
            p: { xs: 2, sm: 3, md: 4 },
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          {/* Header Section */}
          <Box textAlign="center" mb={4}>
            <CheckCircleIcon
              sx={{
                fontSize: { xs: 60, sm: 80 },
                color: "#3e513b",
                mb: 2,
              }}
            />
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                color: "#455245ff",
                fontWeight: "bold",
                mb: 1,
                fontSize: { xs: "1.6rem", sm: "2rem" },
              }}
            >
              ¡Selección Confirmada!
            </Typography>
          </Box>

          <Card
            elevation={3}
            sx={{
              mb: 4,
              borderRadius: 3,
              border: `2px solid #3e513b`,
              width: "100%",
              maxWidth: 600,
              mx: "auto",
              backgroundColor: "#f9faf7",
            }}
          >
            <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent={"center"}
                gap={1}
                sx={{
                  borderBottom: "2px solid #3e513b",
                  pb: 1,
                  mb: { xs: 1, sm: 3 },
                }}
              >
                <RestaurantIcon
                  sx={{ color: "#3e513b", fontSize: { xs: 24, sm: 32 } }}
                />
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{
                    color: "#3e513b",
                    fontWeight: "bold",
                    fontSize: { xs: "1rem", sm: "1.25rem" },
                  }}
                >
                  {nombreCompleto}, esta es tu seleccion semanal:
                </Typography>
              </Box>

              <Box
                component="ul"
                sx={{
                  listStyle: "none",
                  p: 0,
                  m: 0,
                  maxHeight: 280,
                  overflowY: "auto",
                }}
              >
                {Object.keys(pedidosOrdenado).length > 0 ? (
                  Object.entries(pedidosOrdenado).map(([fecha, { id_menu }]) =>
                    id_menu ? (
                      <Box
                        component="li"
                        key={fecha}
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: "space-between",
                          gap: { xs: 0.5, sm: 2 },
                          py: 1,
                          borderBottom: "1px solid #d4d9ce",
                          fontSize: { xs: "0.9rem", sm: "1rem" },
                          color: "#3e513b",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 600,
                          }}
                        >
                          {moment(fecha).format("dddd")}:
                        </Typography>

                        <Typography
                          sx={{
                            fontStyle: "italic",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {id_menu === 0 ? null : changeIdForNameMenu(id_menu)}
                        </Typography>
                      </Box>
                    ) : null
                  )
                ) : (
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    gap={2}
                    sx={{ py: 4 }}
                  >
                    <AssignmentLateIcon
                      sx={{ color: "#3e513b", fontSize: { xs: 24, sm: 32 } }}
                    />
                    <Typography
                      sx={{
                        color: "#000000ff",
                        fontStyle: "italic",
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                      }}
                    >
                      No seleccionaste menu.
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>

          {/* Success Message */}
          <Card
            elevation={2}
            sx={{
              mb: 4,
              backgroundColor: "#e8f5e8",
              borderLeft: `5px solid #3e513b`,
            }}
          >
            <CardContent>
              <Typography
                variant="body1"
                textAlign="center"
                sx={{
                  color: "#2d3e2a",
                  fontWeight: 500,
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                }}
              >
                Tu pedido ha sido registrado exitosamente. Esperamos que las
                disfrutes
              </Typography>
            </CardContent>
          </Card>

          {/* Navigation Buttons */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
          >
            <Button
              variant="outlined"
              size="large"
              startIcon={<ArrowBackIcon />}
              onClick={handleBackToSelection}
              sx={{
                borderColor: "#3e513b",
                color: "#3e513b",
                py: 1.5,
                px: { xs: 3, sm: 4 },
                borderRadius: 2,
                fontWeight: "bold",
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  borderColor: "#2d3e2a",
                  backgroundColor: "#f0f4f0",
                  color: "#2d3e2a",
                },
              }}
            >
              Volver a Seleccionar
            </Button>

            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={handleBackToHome}
              sx={{
                backgroundColor: "#3e513b",
                py: 1.5,
                px: { xs: 3, sm: 4 },
                borderRadius: 2,
                fontWeight: "bold",
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#2d3e2a",
                },
              }}
            >
              Volver al Menú Inicio
            </Button>
          </Stack>

          {/* Footer */}
          <Box textAlign="center" mt={4}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              Netizar
            </Typography>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default OrderConfirmationScreen;
